<template>
    <path :style="{ fill: color }" d="M62.1,59.4c-1.1-1.1-1.1-3-2.2-4.2c-1.5-1.7-4.5-2.9-6.2-0.7c-0.1,0.1-0.2,0.2-0.2,0.3
	c-0.1,0.2-0.2,0.3-0.2,0.5c-0.1-0.2-0.1-0.3-0.2-0.5c-0.1-0.1-0.1-0.2-0.2-0.3c-1.7-2.2-4.7-1-6.2,0.7c-1.1,1.2-1.1,3-2.2,4.2
	c-0.6,0.7-1.5,0.8-2.4,0.6c0.8,1.6,2.5,1.8,4,2c1.8,0.2,3.6-0.9,5.1-1.8c0.9-0.6,1.8-1.7,2.1-2.8c0.3,1.2,1.2,2.2,2.1,2.8
	c1.5,0.9,3.3,1.9,5.1,1.8c1.6-0.1,3.3-0.4,4-2C63.7,60.3,62.8,60.1,62.1,59.4z"/>
</template>

<script>
    import Mouth from './Mouth';

    export default {
        name: 'Mouth5',
        mixins: [Mouth],
    }
</script>
